import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import { SelectFieldOption } from "components/UI/SelectField/SelectField.type";
import { USER_TYPE } from "constant/user/user.constant";

type UserTypeSelectProps = {
  defaultValue?: string;
  label?: string;
  name?: string;
  onSelect?: (value: string) => void;
};

const USER_TYPE_SELECT_OPTIONS: SelectFieldOption[] = [
  { value: USER_TYPE.EDITOR, label: USER_TYPE.EDITOR },
  { value: USER_TYPE.ADMIN, label: USER_TYPE.ADMIN },
];

const UserTypeSelect = ({
  defaultValue = USER_TYPE.EDITOR,
  label = "Tip korisnika",
  name = "uType",
  onSelect,
}: UserTypeSelectProps) => {
  const { control, reset } = useForm({
    defaultValues: {
      [name]: defaultValue,
    },
  });

  useEffect(() => {
    reset({
      [name]: defaultValue,
    });
  }, [defaultValue, name, reset]);

  return (
    <>
      <SelectField
        name={name}
        control={control}
        label={label}
        defaultValue={defaultValue}
        options={USER_TYPE_SELECT_OPTIONS}
        onSelect={onSelect}
      />
    </>
  );
};

export default UserTypeSelect;
